import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _styled from "styled-components";
import { css as _css } from "styled-components";
var _excluded = ["children", "leftEnhancer", "rightEnhancer", "variant", "height", "size"],
  _excluded2 = ["isLoading", "loader"];
import React from "react";
import { Box } from "atomic-layout";
import { Loader } from "../Loader";
import { colors } from "../shared/styles";
var secondaryButton = _css(["border:1px solid ", ";border-radius:6px;color:", ";background:", ";&:disabled{color:", ";border-color:", ";}"], colors.secondaryBlueLight, colors.secondaryBlueLight, colors.plain, colors.grayDark, colors.grayLight);
var tertiaryButton = _css(["border:1px solid ", ";border-radius:6px;color:", ";background:", ";&:disabled{color:", ";border-color:", ";}"], colors.grayRegular, colors.plain, colors.grayRegular, colors.grayDark, colors.grayRegular);
var primaryButton = _css(["border:1px solid ", ";border-radius:6px;color:", ";background:", ";&:disabled{background:", ";color:", ";border-color:", ";}"], colors.secondaryBlueLight, colors.plain, colors.secondaryBlueLight, colors.grayLight, colors.grayDark, colors.grayLight);
var DefaultEnhancer = function DefaultEnhancer(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 14 : _ref$size;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: size,
      height: size
    }
  });
};
export var Button = React.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    leftEnhancer = _ref2.leftEnhancer,
    rightEnhancer = _ref2.rightEnhancer,
    variant = _ref2.variant,
    _ref2$height = _ref2.height,
    height = _ref2$height === void 0 ? 32 : _ref2$height,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 14 : _ref2$size,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(_StyledBox, Object.assign({
    ref: ref,
    as: "button",
    flex: true,
    inline: true,
    flexWrap: "nowrap",
    alignItems: "center",
    justifyContent: "space-between",
    height: height,
    margin: 0,
    paddingVertical: 0,
    paddingHorizontal: Math.round(height / 2)
  }, props, {
    $_css2: height,
    $_css3: size,
    $_css4: variant === "primary" && primaryButton,
    $_css5: variant === "secondary" && secondaryButton,
    $_css6: variant === "tertiary" && tertiaryButton
  }), leftEnhancer ? leftEnhancer : /*#__PURE__*/React.createElement(DefaultEnhancer, null), children, rightEnhancer ? rightEnhancer : /*#__PURE__*/React.createElement(DefaultEnhancer, null));
});
export var LoadingButton = React.forwardRef(function (_ref3, ref) {
  var isLoading = _ref3.isLoading,
    _ref3$loader = _ref3.loader,
    loader = _ref3$loader === void 0 ? /*#__PURE__*/React.createElement(Loader, {
      color: "grayDark"
    }) : _ref3$loader,
    props = _objectWithoutProperties(_ref3, _excluded2);
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    ref: ref
  }, props, {
    leftEnhancer: isLoading && loader,
    disabled: isLoading || props.disabled
  }));
});
var _StyledBox = _styled(Box).withConfig({
  displayName: "Buttons___StyledBox",
  componentId: "sc-1w64ipw-0"
})(["text-decoration:none !important;line-height:", "px;font-size:", "px;outline:none;cursor:pointer;&:hover{opacity:0.7;}&:disabled{opacity:0.7;cursor:not-allowed;}", " ", "  ", " "], function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
}, function (p) {
  return p.$_css4;
}, function (p) {
  return p.$_css5;
}, function (p) {
  return p.$_css6;
});